module.exports = __webpack_public_path__ + "img/bg5.ab709646.png";